<template>
    <div class="content">
        <div v-if="progress.length">
            <!-- Business card -->
            <div class="public div-margin">
                <!-- card -->
                <div :class="objState == 0 || objState == 1 ? 'card-padding': ''" class="card">
                    <!-- img  未完工- unfinished  已完工 - working-->
                    <!-- <div v-if="objState == 0" class="img"></div> -->
                    <!-- <div v-if="objState == 1" class="img"></div> -->
                    <div v-if="objState == 2" class="img uncourse"></div>
                    <div v-if="objState == 3" class="img working"></div>
                    <div v-if="objState == 4" class="img unfinished"></div>
                    <div :class="objState ? '' : 'topping'" class="top">
                        <!-- text -->
                        <div class="text">
                            <div class="text-top">{{ userPactState ? objAccount.new_name : objAccount.new_city_idname + objAccount.new_county_idname + objAccount.new_address }}</div>
                            <div class="text-bottom">
                                <div class="left">{{objAccount.name}}</div>
                                <!-- <div class="right">NO.2021080907655</div> -->
                            </div>
                        </div>
                        <!--  layer -->
                        <!-- <div class="layer">空调壁挂炉</div> -->
                        <!-- lable -->
                        <div class="lable">
                            <div>{{ objAccount.new_area ? objAccount.new_area + ' m²' : '不详'}}</div>
                            <div>
                                {{ objAccount.new_roomnumber ? objAccount.new_roomnumber + '室' : '' }}{{ objAccount.new_hall ? objAccount.new_hall + '厅' : '' }}{{ objAccount.new_toilet ? objAccount.new_toilet + '卫' : '' }}{{ objAccount.new_kitchen ? objAccount.new_kitchen + '厨' : ''}}
                            </div>
                            <div>{{ objAccount.new_housetype_name ?  objAccount.new_housetype_name : '不详'}}</div>
                        </div>
                    </div>
                </div>
                <!--  progress -->
                <div v-if="progress.length > 0" class="progress">
                    <hr class="line" />
                    <template v-for="(item, index) in progress">
                        <div v-if="item.type_name != '现场交底'" :key="index" class="progress-item">
                            <div :class="item.isdata ? 'imgacd' : 'imghide'" class="img"></div>
                            <div :class="item.isdata ? 'item-font' : 'font-text'">
                                <template v-if="index == 4">
                                    {{ item.type_name.slice(0, 3) }}
                                </template>
                                <template v-else>
                                    {{ item.type_name.slice(0, 2) }}
                                </template>
                            </div>
                            <div :class="item.isdata ? 'item-font' : 'font-text'">
                                <template v-if="index == 4">
                                    {{ item.type_name.slice(3, 5) }}
                                </template>
                                <template v-else>
                                    {{ item.type_name.slice(2, 5) }}
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!-- project -->
            <div @click="myProject" class="public project felx-center div-margin">
                <div class="project-left felx-center">
                    <img class="left" src="~@/assets/images/user/house/project.png" alt="" />
                    <div class="right font-text1">我的项目</div>
                </div>
                <div class="project-right felx-center">
                    <div class="left font-text">{{ objProject.new_name ? objProject.new_name : ''}}</div>
                    <div class="right"></div>
                </div>
            </div>
            <!-- menu -->
            <div v-if="arrbtn.length > 0" class="meun div-margin">
                <div class="felx-center meun-list">
                    <!-- <div @click="meunClick(1,0)" class="meun-item">
                        <img v-if="!arrbtn[0].isdata" src="~@/assets/images/user/house/report.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/noreport.png" alt="" />
                        <div :class="arrbtn[0].isdata ? 'font-color' : ''" class="font-text">勘察报告</div>
                    </div> -->
                    <div class="Train" @click="meunClick(3,2)">
                        <img v-if="!arrbtn[2].isdata" src="~@/assets/images/user/house/3d_icon.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/no3d_icon.png" alt="" />
                        <div :class="arrbtn[2].isdata ? 'font-color' : ''" class="font-text">3D设计方案</div>
                    </div>
                    <!-- <div @click="meunClick(2,1)" class="meun-item">
                        <img v-if="!arrbtn[1].isdata" src="~@/assets/images/user/house/make_icon.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/nomake_icon.png" alt="" />
                        <div :class="arrbtn[1].isdata ? 'font-color' : ''" class="font-text">项目方案书</div>
                    </div> -->
                    <div class="Train" @click="meunClick(11,5)">
                        <img v-if="!arrbtn[5].isdata" src="~@/assets/images/user/house/progress.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/noprogress.png" alt="" />

                        <div :class="arrbtn[5].isdata ? 'font-color' : ''" class="font-text">施工及验收</div>
                    </div>
                </div>
                <div class="felx-center meun-list">
                    <div class="meun-item" @click="meunClick(4,3)">
                        <img v-if="!arrbtn[3].isdata" src="~@/assets/images/user/house/contract.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/nocontract.png" alt="" />
                        <div :class="arrbtn[3].isdata ? 'font-color' : ''" class="font-text">合同备忘</div>
                    </div>
                    <div class="meun-item" @click="meunClick(6,4)">
                        <img v-if="!arrbtn[4].isdata" src="~@/assets/images/user/house/team.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/noteam.png" alt="" />
                        <div :class="arrbtn[4].isdata ? 'font-color' : ''" class="font-text">项目团队</div>
                    </div>
                    <div class="meun-item" @click="meunClick(9,6)">
                        <img v-if="!arrbtn[6].isdata" src="~@/assets/images/user/house/contract1.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/nocontract1.png" alt="" />

                        <div :class="arrbtn[6].isdata ? 'font-color' : ''" class="font-text">竣工验收</div>
                    </div>
                    <div class="meun-item" @click="meunClick(0,8)" >
                        <img v-if="!arrbtn[8].isdata" src="~@/assets/images/user/house/Train.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/noTrain.png" alt="" />
                        <div :class="arrbtn[8].isdata ? 'font-color' : ''" class="font-text">总裁直通车</div>
                    </div>
                </div>
                <div class="felx-center meun-list">
                    <!-- <div class="meun-item" @click="meunClick(10,8)">
                        <img v-if="!arrbtn[8].isdata" src="~@/assets/images/user/house/assure.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/noassure.png" alt="" />

                        <div :class="arrbtn[8].isdata ? 'font-color' : ''" class="font-text">承保书</div>
                    </div> -->
                    <!-- <div class="meun-item" @click="meunClick(7,10)">
                        <img v-if="!arrbtn[10].isdata" src="~@/assets/images/user/house/give.png" alt="" />
                        <img v-else src="~@/assets/images/user/house/nogive.png" alt="" />

                        <div :class="arrbtn[10].isdata ? 'font-color' : ''" class="font-text">我要推荐</div>
                    </div> -->
                </div>
            </div>
            <!-- 质量验收标准 -->
            <div @click="openLook(imgUrl.picurl)" class="quality div-margin" v-if="imgUrl.imgurl">
                <img :src="imgUrl.imgurl" alt="">
            </div>

            <!-- 已签合同 -->
            <template v-if="objState != 1 && objState != 0">
                <!-- project -->
                <div @click="myNews" class="public project felx-center div-margin">
                    <div class="project-left felx-center">
                        <img class="left" src="~@/assets/images/user/house/message.png" alt="" />
                        <div class="right font-text1">我的消息</div>
                    </div>
                    <div class="project-right felx-center">
                        <div class="left font-text">更多</div>
                        <div class="right"></div>
                    </div>
                </div>
                <div class="sign div-margin">
                    <div v-for="(item, index) in arrMessageList" :key="index" class="felx-center sign-item" @click="getChangeList(item)">
                        <div class="font-text1 left omit">{{ item.data.detail_msg }}</div>
                        <div class="font-text right">{{ item.data.finish_time }}</div>
                    </div>
                </div>
            </template>

            <!-- 未签合同 -->
            <template v-else>
                <!-- project -->
                <div class="public project felx-center div-margin">
                    <div class="project-left felx-center">
                        <img class="left" src="~@/assets/images/user/house/mouth.png" alt="" />
                        <div class="right font-text1">业主口碑</div>
                    </div>
                    <div class="project-right felx-center">
                        <div class="left font-text" @click="$router.push('/antMap/index')">更多</div>
                        <div class="right"></div>
                    </div>
                </div>
                <div class="nosign">
                    <swiper ref="mySwiper" :options="swiperOption" class="swiper">
                        <swiper-slide v-for="(item, index) in arrCaseList" :key="index" class="swiper-list">
                            <div class="swiper-item" @click="godetails(item)">
                                <!-- 小标签 -->
                                <div class="label_tips">
                                    {{item.status}}
                                </div>
                                <div class="item-title">{{item.type}}｜{{item.city}}{{item.name}}</div>
                                <div class="item_content">
                                    <span class="pfm">
                                        {{ item.house_area }}
                                    </span>
                                    <span class="type">
                                        {{ item.house_cate }}
                                    </span>
                                    <span class="share_num">
                                        {{ item.views || item.real_views }}
                                    </span>
                                </div>
                                <div class="item_img_url">
                                    <div class="img_url" v-for="(imgitem,imgindex) in item.images" :key="imgindex">
                                        <img v-lazy="imgitem.img_url" alt="">
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </template>
        </div>
        <!--   鉴权潜客   -->
        <el-authority @changeLogin = "changeLogin"></el-authority>
    </div>
</template>

<script>
import oStorage from '@/libsV2/storage.js';
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import elAuthority from "@/components/hvac/authority/index.vue";
import { getProjectList } from "@/js/map.js";
import { getNotify , getChange } from "@/js/member/mynews/index.js";
import { getWxSingleConfig, wxGetLocationH5, geoGetLocation } from "@/js/wx.js";
export default {
    components: {
        Swiper,
        SwiperSlide,
        elAuthority,
    },
    data() {
        return {
            abnormal: true, //是否绑定
            progress: [], // 设计进度
            userPactState: false, // 合同状态
            swiperOption: {
                loop: false, // 循环回路
                slidesPerView: "auto", // 设置slider容器能够同时显示的slides数量; 设置为auto则自动根据slides的宽度来设定数量
                centeredSlides: false, // 设定为true时，active slide会居中，而不是默认状态下的居左
                spaceBetween: 12, // 每个swiper-slide之间的间隔
            },

            objAccount: {}, // 用户信息
            arrbtn: [
                // 用户切换
            ],
            objProject: {}, // 用户项目
            arrMessage: [
                {data:{detail_msg:'',finish_time:''}}
            ], // 我的消息
            arrMessageList:[{data:{detail_msg:'',finish_time:''}}],
            arrImg: [], // 业主口碑
            objState: null, // 合同状态

            imgUrl: {}, // 图片
            imgIndex: 0,
            lookImgIndex: 0,
            images: [],
            nContractId: 0, //合同id
            arrCaseList:[], //项目案例列表
        };
    },
    created() {
        this.$store.commit("loadSkeleton", { bool: true, type: "home" }); // 页面loading开启
        Promise.all([this.getBound(),this.getUserNotify(),getWxSingleConfig()])
    },
    watch:{
        $router(to,from){
		    console.log(to.path,form)
        }
    },
    methods: {
        changeLogin(e){
            that.getUserHouse();
        },
        getChangeList(item){
            let _that = this;
            getChange({message_id:item.id}).then(res=>{
                _that.$router.push({ path: "/member/mynews/index" });
            })
        },
        getUserNotify(e){
            let _that = this;
            getNotify({page:0,limit:20,type:0}).then(res=>{
                let arr = res.data.data.result.list;
                _that.arrMessageList = arr;
            })
        },
        openLook(index) {
            this.$router.push({ path: "/member/standard/index" });
        },
        getBound() {
            let that = this;
            let sampleroom = this.$route.query.sampleroom;
            if(sampleroom){
                that.getUserHouse();
            }else{
            that.$oInitData.memberInfo({
                h5_user_id: that.$storage.getStorage("user_id"),
            }).then((res) => {
                that.getUserHouse();
            }).catch((error) => {
                this.abnormal = false;
            });
            }
        },
        // 绑定成功调用接口
        getUserHouse() {
            let data = {
                sampleroom: this.$route.query.sampleroom,
                accountid: this.$route.query.accountid,
                contractid:this.$route.query.contractid,
            }
            Promise.all([this.$userHouse.dispatch("getHouser",data),this.$store.dispatch("banner/getData", 7)]).then((res) => {
                this.objAccount = this.$userHouse.state.usreHouserList.account; // 用户信息
                this.progress = this.$userHouse.state.usreHouserList.btn_cur; // 合同进度
                this.progress.forEach((item) => {
                    if (item.type_name == "合同签订") {
                        // 如果没有签订合同 ，头部只显示用户地址，签订了，显示用户地址加项目地址；
                        this.userPactState = item.type_id == 0 || item.type_id == "" ? false : true;
                    }
                    item.isdata = item.type_id == 0 || item.type_id == "" ? false: true;
                });
                this.objProject = this.$userHouse.state.usreHouserList.project; // 用户项目
                this.arrbtn = this.$userHouse.state.usreHouserList.btn; // 用户切换
                this.arrbtn.forEach((item) => {
                    // 统一图标点亮
                    item.isdata = item.type_id == 0 || item.type_id == "" ? false : true;
                });
                this.arrMessage = this.$userHouse.state.usreHouserList.message; // 我的消息
                this.arrImg = this.$userHouse.state.usreHouserList.topic; // 业主口碑
                this.objState = this.$userHouse.state.usreHouserList.contract.new_status; // 合同状态
                let cityId = this.$userHouse.state.usreHouserList.account.city_id; // 合同状态
                if (this.objState == 1 || this.objState == 0) {
                    wxGetLocationH5().then((addresInfo) => {
                        this.getProjectList(
                            addresInfo.latitude,
                            addresInfo.longitude,
                            cityId
                        );
                    });
                }
                this.imgUrl = this.$store.state.banner.index; // 图片
                this.$store.commit("loadSkeleton", {bool: false,type: "home",}); // 页面loading关闭
                console.log('关闭load')
                // 设置合同id
                this.$userHouse.state.usreHouserList.btn_cur.forEach((item) => {
                    if (item.type_key == "contract") {
                        this.nContractId = item.type_id;
                    }
                });
            }).catch((error) => console.log(error, "7777"));
        },
        /**
         * 获取分享标识
         * @return {{value: string, key: string}}
         */
        getShareLabel() {
            const url = new URL(location.href);
            // 约定的出口类型 search_key;
            const key = this.$store.state.shareOutKey;
            return {key, value: url.searchParams.get(key)}
        },
        godetails(event){
            const that = this;
            const id = event.id;
            const img = event.images.length?event.images[0].img_url:'';
            const {type, city, community_name, images} = event;
            const img_url = images.length?images[0].img_url:'';
            const ut_source = this.$route.query.ut_source;
            const qywxUserId = this.$route.query.qywxUserId;
            let parame = {type, city, community_name, img_url, ut_source, qywxUserId};
            let dataSet = encodeURIComponent(JSON.stringify(parame));
            var ua = window.navigator.userAgent.toLowerCase();
            // localStorage.setItem("detailImg", img);
            oStorage.setStorage("detailImg", img);

            // 版本
            const version = event.version;

            const label = this.getShareLabel();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                if (ua.match(/WxWork/i) == "wxwork") {
                    if (wx?.miniProgram?.getEnv) {
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                // alert("小程序环境下逻辑");
                                wx.miniProgram.navigateTo({
                                    url: `/pages/antdetails/index?id=${id}&parame=${dataSet}`,
                                });
                            } else {
                                //非小程序环境下逻辑
                                // alert("非小程序环境下逻辑");
                                that.$router.push({path: version === 1 ? "/antdetails/index" : '/project/detail/construction', query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating'}});
                            }
                        });

                    } else {
                        //企业微信环境下
                        that.$router.push({path:version === 1 ? "/antdetails/index" : '/project/detail/construction', query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating'}});
                    }
                } else {
                    //判断是否是微信环境
                    //微信环境

                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            // 小程序环境下逻辑
                            // alert("小程序环境下逻辑");
                            wx.miniProgram.navigateTo({
                                url: `/pages/antdetails/index?id=${id}&parame=${dataSet}`,
                            });
                        } else {
                            //非小程序环境下逻辑
                            that.$router.push({path: version === 1 ? "/antdetails/index" : '/project/detail/construction', query: {id, [label.key]: [label.value], qywxUserId, ut_source: 'ai_heating',}});
                        }
                    });
                }
            } else {
                // 非微信环境逻辑
                // alert("非微信环境逻辑");
                that.$router.push({path: version === 1 ? "/antdetails/index" : '/project/detail/construction', query: {id, qywxUserId, ut_source: 'ai_heating',}});
            }
        },
        // 项目案例列表
        async getProjectList(lat, lng, id) {
            let _that = this;
            const requestData = {
                page: 0,
                row: 4,
                longitude: lng,
                latitude: lat,
                cityId: id,
            };
            const resultData = await getProjectList(requestData);
            _that.arrCaseList = resultData.data.data.result.lists;
        },
        myProject() {
            // 跳转到我的项目
            // if(!this.objProject.new_address) return this.$toast('暂无项目');
            this.$router.push({ path: "/member/project/lists" });
        },
        myNews() {
            // 我的消息
            // if (true) return this.$toast("功能未完善");
            this.$router.push({ path: "/member/mynews/index" });
        },
        meunClick(index, btnIndex) {
            // 点击meun
            if (!this.arrbtn[btnIndex].isdata) return;
            const { contract, project } = this.$userHouse.state.usreHouserList;
            switch (index) {
                case 1:
                    let repid = this.arrbtn.find((it) => {
                        return it.isdata && it.type_key == "mapping";
                    });
                    this.$router.push({
                        path: `/member/project/mapping?contract_id=${
                            this.$userHouse.state.userInfor.default_contact ||
                            ""
                        }&id=${repid.type_id}`,
                    });
                    break;
                case 2:
                    let objReport = this.arrbtn.find((it) => {
                        return it.isdata && it.type_key == "plan";
                    });
                    if (!objReport) return;
                    this.$router.push({
                        path: "/member/project/plan",
                        query: {
                            reportId: objReport.type_id,
                        },
                    });
                    break;
                case 3:
                    let objHref = this.arrbtn.find((it) => {
                        return it.isdata && it.type_key == "third_img";
                    });
                    if (!objHref) return;
                    window.location.href = objHref.type_id;
                    break;
                case 4:
                    this.$router.push({
                        path: "/user/house/survey",
                        query: { contractId: this.nContractId },
                    });
                    break;
                case 5:
                    this.$router.push({ path: "/user/house/prospect" });
                    break;
                case 6:
                    this.$router.push({ path: "/user/house/projectteam" });
                    break;
                case 7:
                    this.$router.push({ path: "/user/house/recommend" });
                    break;
                case 9:
                    // 需要给竣工评价页面传三个参数
                    //processName项目名称
                    //contract_id合同id
                    //topic_id 项目id
                    window.location.href = `${window.location.origin}/user/house/finish?company_id=${contract.new_contractid}&project_uuid=${project.new_srv_projectmgnid}&contract_id=${contract.new_contractid}&processName=${project.new_name}`;
                    break;
                case 10:
                    let objcover = this.arrbtn.find((it) => {
                        return it.isdata && it.type_key == "cover";
                    });
                    if (!objcover) return;
                    this.$router.push({ path: "/member/covernote/index" });
                    break;
                case 11:
                    // window.location.href = `${window.location.origin}/member/process/index?projectmgnid=${project.new_srv_projectmgnid}`;
                    this.$router.push({
                        path: "/member/process/index",
                        query: { projectmgnid: project.new_srv_projectmgnid },
                    });
                    // /member/process/index
                    break;
                    case 0:
                    window.location.href = 'https://smith.udesk.cn/im_client/?web_plugin_id=170594&group_id=281404';
                    break;
                default:
                    break;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./index";
.nodata {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
}
</style>
